import React, { Component } from "react";

import { Row, Col, Button, Popconfirm, Table, Input, Select } from "antd";
import PropTypes from "prop-types";
import { app, api, config } from "../../app";
import utils from "../../utils";

const Option = Select.Option;

class NewsRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      total: 0,
      search_content: undefined,
      audit_status: -1,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.handleRecordData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // 监听输入
  inputMotify = (e) => {
    // search_value
    this.setState({
      search_content: e.target.value,
    });
    // console.log(e.target.value);
  };

  // 去搜索
  toSearchBtn = () => {
    this.setData({ page: 1 });
    this.handleRecordData();
  };

  setData = (data) => app.setStateSync(this, data);

  /**
   * 记录数据
   * @returns {Promise<void>}
   */
  handleRecordData = async (page = 1) => {
    let { search_content, audit_status } = this.state;
    await this.setData({ page, data_loading: true });
    let params = {
      audit_status: audit_status,
      search_content,
      page,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    let { flag, data, msg, total } = await app.post(
      api.productCoinListAdimn,
      params
    );
    if (flag !== 1) {
      app.alert(msg, "error");
      data = [];
    }
    await this.setData({
      dataList: utils.addArrayKey(data),
      data_loading: false,
      total: Number(total || 0),
    });
  };

  render() {
    let { dataList, data_loading, page, total } = this.state,
      columns = [
        {
          title: "商品图",
          dataIndex: "product_img",
          key: "product_img",
          width: "15%",
          render: (img) => {
            if (img && img.includes(":::")) {
              img = img.split(":::")[0]; // 取第一个分割后的值
            }

            return <img width={80} height={80} src={config.imgUrl + img} />;
          },
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
          width: "15%",
        },
        {
          title: "队员姓名",
          dataIndex: "vname",
          key: "vname",
          width: "15%",
        },
        {
          title: "手机号码",
          dataIndex: "mobile",
          key: "mobile",
          width: "15%",
        },
        {
          title: "兑换积分/件",
          dataIndex: "coin_integral",
          key: "coin_integral",
          width: "15%",
          render: (text) => {
            return <span>{text} 分</span>;
          },
        },
        {
          title: "兑换数量",
          dataIndex: "number",
          key: "number",
          width: "15%",
          render: (text) => {
            return <span>{text} 件</span>;
          },
        },
        {
          title: "兑换状态",
          dataIndex: "audit_status",
          key: "audit_status",
          width: "15%",
          render: (text, { audit_time, audit_admin }) => {
            return (
              <div>
                <p>{audit_admin}</p>
                <p>{text == 0 ? "待核销" : text == 1 ? "已核销" : " "} </p>
                <p>{audit_time}</p>
              </div>
            );
          },
        },
        {
          title: "申请时间",
          dataIndex: "create_time",
          key: "create_time",
          width: "15%",
          render: (text) => {
            return <span>{text || "无"} </span>;
          },
        },
      ];
    return (
      <div style={{ marginTop: 20 }}>
        <Row className="pro-table-title">
          <Col
            span={6}
            style={{
              textAlign: "left",
              display: "flex",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <Input.Group compact>
              <Input.Search
                onSearch={() => this.toSearchBtn()}
                onChange={(e) => this.inputMotify(e)}
                style={{ width: 240, marginRight: 32 }}
                enterButton="搜索"
                placeholder="请输入内容搜索"
              />
            </Input.Group>
          </Col>
          <Col span={6}>
            <span style={{ fontSize: 18 }}>状态：</span>
            <Select
              defaultValue="-1"
              style={{ width: 120 }}
              onChange={async (value) => {
                await this.setData({ audit_status: value, page: 1 });
                await this.handleRecordData();
              }}
            >
              <Option value="-1">全部</Option>
              <Option value="1">已核销</Option>
              <Option value="0">待核销</Option>
            </Select>
          </Col>
        </Row>
        <Table
          size="small"
          className="table-odd-even-row"
          bordered={true}
          locale={app.tbLocale(data_loading)}
          columns={columns}
          dataSource={dataList}
          loading={data_loading}
          pagination={{
            current: page,
            total,
            pageSize: 20,
            showTotal: (t) => `总数量：${t}`,
            onChange: this.handleRecordData,
          }}
          scroll={{ y: "calc(100% - 46px)" }}
        />
      </div>
    );
  }
}

NewsRecord.propTypes = {
  openDetail: PropTypes.func,
  record_id: PropTypes.any,
};

export default NewsRecord;



// WEBPACK FOOTER //
// ./src/routes/grade/recordChart.jsx